/// <amd-module name="Checks/ChecksOverview/ChecksStore" />
import { ChecksActions } from "Checks/ChecksOverview/ChecksActions";
import * as PipelineChecksContracts from "Checks/Client/Contracts/PipelinesChecks";

import { TimerManagement } from "VSS/Core/TimerManagement";
import * as VSSStore from "VSS/Reflux/Store";

export class ChecksStore extends VSSStore.Store {
        constructor(checksDetailsData: PipelineChecksContracts.CheckConfigurationData[], checkDefinitions: PipelineChecksContracts.CheckDefinitionData[]) {
        super("checks-store");
        this._checkConfigurationDataList = checksDetailsData || [];
        this._checkDefinitions = checkDefinitions;
        this._throttledSearch = this._timerManagement.debounce((searchText: string) =>  this._searchChecks(searchText), 250);
        this._addListeners();
    }

    public dispose() {
        this._removeListeners();
    }

    public getState(): PipelineChecksContracts.CheckConfigurationData[] {
        return this._checkConfigurationDataList;
    }

    public _getFilteredCheckDefinitions() {
        return this._filteredCheckDefinitions;
    }

    public _getCheckDefinitions() {
        return this._checkDefinitions;
    }

    private _addListeners(): void {
        this._actionsHub.addCheck.addListener(this._handleAddCheck);
        this._actionsHub.deleteCheck.addListener(this._handleDeleteCheck);
        this._actionsHub.updateCheck.addListener(this._handleUpdateCheck);
        this._actionsHub.filterChecks.addListener(this._filterChecks);
    }

    private _removeListeners(): void {
        this._actionsHub.addCheck.removeListener(this._handleAddCheck);
        this._actionsHub.deleteCheck.removeListener(this._handleDeleteCheck);
        this._actionsHub.updateCheck.removeListener(this._handleUpdateCheck);
        this._actionsHub.filterChecks.removeListener(this._filterChecks);
    }

    private _handleAddCheck = (checkConfigurationData: PipelineChecksContracts.CheckConfigurationData) => {
        this._checkConfigurationDataList.push(checkConfigurationData);
        this.emitChanged();
    }

    private _handleUpdateCheck = (updatedCheck: PipelineChecksContracts.CheckConfigurationData) => {
        if (this._checkConfigurationDataList && this._checkConfigurationDataList.length > 0) {
            let checkIndex = this._checkConfigurationDataList.findIndex(checkConfigurationData => checkConfigurationData.checkConfiguration.id === updatedCheck.checkConfiguration.id);
            if (checkIndex !== -1) {
                this._checkConfigurationDataList[checkIndex] = updatedCheck;
                this.emitChanged();
            }
        }
    }

    private _handleDeleteCheck = (checkAssignmentId: number) => {
        if (this._checkConfigurationDataList && this._checkConfigurationDataList.length > 0) {
            this._checkConfigurationDataList = this._checkConfigurationDataList.filter(checkConfigurationData => checkConfigurationData.checkConfiguration.id !== checkAssignmentId);
            this.emitChanged();
        }
    }

    private _filterChecks = (value: string) => {
        this._throttledSearch(value);
    }

    private _searchChecks = (searchText: string) => {
        searchText = searchText.toLowerCase();
        if (searchText === "") {
            this._filteredCheckDefinitions = this._checkDefinitions;
        }
        else {
            const searchTextValues = searchText.split(" ");
            this._filteredCheckDefinitions = this._checkDefinitions.filter(c => {
                return searchTextValues.every(value => c.name.toLocaleLowerCase().indexOf(value) >= 0 || c.description.toLocaleLowerCase().indexOf(value) >= 0);
            });
        }
        this.emitChanged();
    }

    private _checkConfigurationDataList: PipelineChecksContracts.CheckConfigurationData[];
    private _actionsHub: ChecksActions = ChecksActions.getInstance();
    private _checkDefinitions: PipelineChecksContracts.CheckDefinitionData[];
    private _throttledSearch: (searchText: string) => void;
    private _timerManagement = new TimerManagement();
    private _filteredCheckDefinitions: PipelineChecksContracts.CheckDefinitionData[] = [];
}